import {DataHubService} from "../../modules/DataHubModule";
import {QbSyncStateDto} from "../../model/QbSyncStateDto";
import {QbXmlRequestDto} from "../../model/QbXmlRequestDto";
import {DisposeBag} from "../../modules/DisposeBag";
import {HookResult, Ng1Controller, Transition} from "@uirouter/angularjs";
import {IToasterService} from "ngtoaster";

export default class QbXmlRequestController implements Ng1Controller {
    private request: QbXmlRequestDto;
    private disposeBag = new DisposeBag();

    $onInit(): void {
        // this.reload();
    }

    uiCanExit(transition: Transition): HookResult {
        this.disposeBag.finalize();
        return undefined;
    }

    uiOnParamsChanged(newValues: any, $transition$: Transition): void {
    }


    constructor(private $dataHub: DataHubService, private $stateParams, private toaster: IToasterService) {
        $dataHub.onQbXmlRequestUpdated(ret => {
            if (ret.guid == this.$stateParams.guid)
                this.request = ret;
        }, this.disposeBag);
        $dataHub.onConnected(this.reload, this.disposeBag);
    }


    reload = () => {
        if (!this.$dataHub.isConnected) return;

        this.$dataHub.qbXmlRequestSubscribeOne(this.$stateParams.guid)
            .then(ret => this.request = ret);
    }

    cancel = () => {
        this.$dataHub.qbXmlRequestCancel(this.request.guid)
            .then(() => this.toaster.success('Request canceled'))
            .catch(this.$dataHub.defaultErrorHandler);
    }

}
